import { render, staticRenderFns } from "./RoomRecordDetails.vue?vue&type=template&id=35f459ca&"
import script from "./RoomRecordDetails.vue?vue&type=script&lang=js&"
export * from "./RoomRecordDetails.vue?vue&type=script&lang=js&"
import style0 from "./RoomRecordDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports